/* eslint-disable react/no-danger */
import { Col, Container, Row } from 'reactstrap';

export default function PrivacyJp() {
  return (
    <section className="content-page-wrapper">
      <Container>
        <Row>
          <Col xl={{ size: 8, order: 2, offset: 2 }}>
            <h1>プライバシーポリシー</h1>
            <p>
              株式会社 Zenyum Japan(以下「当社」といいます)では、お客様の個人情報を保護することの重要性を認識しており、個人情報保護法に基づき、お客様の個人情報を含む利用者情報（以下「個人情報等」といいます。）
              を適切に管理、保護、処理する責任を真剣にとらえています。このプライバシーポリシー（以下「本ポリシー」といいます）では、当社が所有・
              運営する以下の資産を含む当社のサービス、ウェブサイト、プラットフォーム、デバイス、アプリケーション、プログラム、サーバー、ソフトウェアとお客様とのやり取りを通じて、
              当社がどのようにお客様の個人情報を収集、使用、開示または処理するかについて説明します。
            </p>
            <p>
              (i) www.zenyum.comおよび関連するアプリケーションやサービスを含む、当社が所有・運営するウェブサイト(以下「当社ウェブサイト」)、
              (ii) あらゆるソーシャルメディア・プラットフォーム(Facebook、Instagram、Twitter、LinkedIN、WeChat、YouTube、Telegram、
              WhatsAppを含むがこれらに限定されない)上で当社が作成した公式ソーシャルメディア・チャンネル(以下「当社チャンネル」)、および
              (iii) リンク等で本ポリシーを参照しているその他のすべてのプロパティ(以下「当社サービス」と総称)。
              本ポリシーは、当社とお客様との間のすべてのやり取り、および本プライバシーポリシーを参照またはリンクしているその他のサービスに適用されます。
            </p>
            <p>
              本ポリシーにおいて、「個人情報」とは、お客様が当社サービスをご利用になることにより、お客様が当社に提供した、または当社がお客様から収集した、個人を特定できる情報（他の情報と容易に照合することができ、
              それにより特定の個人を識別することができることとなるものを含む。）で、生存する個人に関する情報を意味します。
              本ポリシーをよくお読みいただき、当社がお客様の個人情報等をどのように管理、保護、処理するかについてご質問がある場合は、当社のデータ保護担当者（
              <a href="mailto:smile.japan@zenyum.com">smile.japan@zenyum.com</a>
              ）までご連絡ください。
            </p>
            <p>
              本ポリシーは、日本の法律に準拠しています。当社サービスの利用を継続することにより、お客様は本ポリシーおよび当社の利用規約
              （アクセス先：
              <a href="http://zenyum.com/jp-ja/website-terms-and-conditions">
                www.zenyum.com/jp-ja/website-terms-and-conditions
              </a>
              ）
              の条件に同意したものとみなされ、本契約は、お客様の個人データの使用に関して当社がお客様と交わした他のいかなる契約にも優先します。
              当社ウェブサイトおよび当社チャンネルの一部の機能は、お客様の個人データの提供を必要とし、お客様がそのような要求された情報を提供しない場合、私たちはお客様にサービスを提供できないことがあります。
            </p>
            <p>
              当社は、個人情報等がその親権者もしくは保護者から収集されたものである場合、または親権者もしくは保護者の事前の同意を得たものである場合を除き、
              18歳未満の方の個人情報等を収集する意図はありませんが、そのような方の当社ウェブサイトや当社チャンネルへのアクセスや訪問を阻止することはできません。
              お客様が 18歳未満の場合(または当社サービスに合法的にアクセスまたは使用するために必要な年齢)、同意、アクセス、修正の権利はお客様の親権者または後見人によってのみ認められます。
              お客様が当該個人の親権はまたは後見人である場合、18歳未満の個人の個人データを当社に提供することにより、お客様はここに、適用される法律に従って当該個人の個人情報等が処理されることに同意し、
              本プライバシーポリシーの条項に個人的に拘束され、ウェブサイトおよびチャンネルに関連する当該個人の行動に全責任を負うことに同意するものとします。
              本ポリシーに同意しない場合、または親権者もしくは法定代理人等の同意がない場合は、直ちに当社に通知し、当社サービスの使用を中止してください。
            </p>
            <ol>
              <li>
                当社が収集する個人情報等
                <ul>
                  <li>
                    当社は、当社の「Zenyum Invisible Braces」（透明な歯列矯正具）および当社が開発した関連製品を用いた歯列矯正治療を、
                    日本で歯科医業を営むために登録された歯科医、またはその他の第三者のサービスプロバイダーと協力して提供しています（以下、総称して「Zenyum治療」といいます）。
                  </li>
                  <li>
                    収集される個人情報等の主体
                    <br />
                    当社のサービスを利用することにより、以下のいずれかに該当する個人について、個人情報等収集の対象となることがあります。
                    <br />
                    (i) ウェブサイトまたはチャンネルの訪問者
                    <br />
                    (ii) 顧客(iii)患者（過去もしくは将来において患者となる見込みの者を含む）
                    <br />
                    (iv) そのような患者の親/後見人
                    <br />
                    (v) 歯科医/その他の歯科医療専門家
                  </li>
                  <li>
                    個人情報等の収集
                    <br />
                    本サービスを利用するにあたり、お客様の氏名、年齢、連絡先、歯並びに関する健康情報（画像データを含みます）
                    、地理的な位置などの個人データの提供を適宜求められることがあります。当社は、お客様の体験をお客様に合わせたものとし、
                    当社サービスを改善するために、お客様、お客様の正式な代理人、および／または当社の第三者サービスプロバイダー（パートナーや第三者アプリケーションなど）
                    から直接、お客様の個人データを収集することがあります。
                  </li>
                  <li>
                    要配慮個人情報
                    <br />
                    要配慮個人情報とは、本人の人種、信条、社会的身分、病歴、犯罪の経歴、犯罪により害を被った事実その他本人に対する不当な差別、
                    偏見その他の不利益が生じないようにその取扱いに特に配慮を要するものとして政令で定める記述等が含まれる個人情報をいいます。
                    当社は、歯の治療に関して、本人の同意を得たうえで、要配慮個人情報を取得する場合があります。当社は、個人情報保護法第
                    17条 2項各号に定める場合を除いて、要本人の同意なく配慮個人情報を取得することはありません。
                  </li>
                  <li>
                    本ポリシーへの同意
                    <br />
                    お客様が本サービスにアクセスしたり、本サービスを利用したり、あるいはお客様の個人データを当社に提供することにより、当社は、
                    お客様が本プライバシーポリシーの条項を理解し、これに同意し、当社によるお客様の個人情報等の収集、
                    使用および開示に同意したものとみなされます。これらの条件のいずれかに同意されない場合は、当社のサービスにアクセスしたり、
                    使用したり、お客様の個人データを当社に提供したりしないでください。
                  </li>
                </ul>
              </li>
              <li>
                個人情報等の収集、使用、開示、処理の目的
                <ul>
                  <li>
                    社は、お客様に関連するサービスを提供し、当社の事業を運営するために、お客様の個人データを使用します。また、当社は、本サービスの新機能、セキュリティアップデート、またはお
                    客様のアカウントに関する情報をお知らせするなど、お客様とのコミュニケーションのために収集したデータを使用することがあります。

                  </li>
                  <li>
                    客様の個人データは、本サービスまたは第三者のアプリケーションを通じて、また他の情報源からの情報と組み合わせて、お客様により関連性の高い情報、
                    コンテンツ、広告を表示するために使用される場合もあります。
                  </li>
                  <li>
                    社がお客様の個人情報等の利用目的としては、次のようなものがあります。
                    <br />
                    <br />
                    <ul>
                      <li>お客様の取引やご要望を処理、記録、監視、実現するため。</li>
                      <li>本サービスの提供を促進するため</li>
                      <li>調査、マーケティング、広告、プロモーションのためのお客様とのコミュニケーション</li>
                      <li>お客様の本サービスの購入および購読、お客様のアカウントの管理、メーリングリストへの登録の処理などの管理事項。</li>
                      <li>本サービスの診断および保守</li>
                      <li>本サービスのセキュリティを維持するため。</li>
                      <li>お客様および本サービスの他のユーザーや訪問者を保護するため。</li>
                      <li>当社のポリシーおよび手順の実施</li>
                      <li>お客様からの質問、フィードバック、苦情の受付のため。</li>
                      <li>お客様に適宜通知するため。</li>
                    </ul>

                  </li>
                  <li>
                    客様が訪問者、患者（過去もしくは将来において患者となる見込みのものを含む）、または当該患者の親権者/保護者（以下、総称して「患者」）
                    である場合、当社によるお客様の個人情報の利用目的には以下のようなものがあります。
                    <br />
                    <br />
                    <ul>
                      <li>オンライン施設へのアクセス、提携歯科医／その他歯科医療従事者への予約を可能にするため</li>
                      <li>歯科医師、その他の歯科医療従事者の詳細をお客様に提供するため。</li>
                      <li>   Zenyum治療への適合性を判断するための予備的な適合性評価レポートを作成するため。</li>
                    </ul>
                  </li>
                  <li>
                    お客様が歯科医師、その他の歯科医療従事者である場合、あなたの個人情報等の利用目的としては次のものがあります。
                    <br />
                    <br />
                    <ul>
                      <li> 将来の患者または実際の患者に関する情報を提供するため。</li>
                      <li>患者からの予約やその他のリクエストを受け付けるため、および/または</li>
                      <li>患者様が閲覧可能なプロフィールを作成するため（歯科医師の氏名・連絡先、歯科医院の名称・連絡先、診療経験や専門分野などの関連情報を含む）。</li>
                    </ul>
                  </li>
                  <li>お客様の個人情報の利用方法（利用目的）は、その時々の状況に応じて異なりますが、適用される法律および規制を遵守して利用されます。</li>
                  <li>
                    当社は、上記に定める利用目的を、変更前の利用目的と関連性を有すると合理的に認められる範囲内において変更することがあり、変更した場合には、
                    お客様に対し、通知または当社ウェブサイト上での掲示その他の方法により公表します。
                  </li>
                  <li> 当社は、当社の支配権の変更または売却を促進するため、あるいは組織再編やその他の企業再編を促進するために、お客様の個人情報を処理し利用することがあります。</li>
                </ul>
              </li>
              <li>
                お客様の個人データの第三者への提供および共同利用
                <br />
                <ul>
                  <li>
                    当社は、原則として、利用者本人の同意を得ずに個人情報および要配慮個人情報を第三者に提供しません。ただし、以下の場合は、関係法令に反しない範囲で、
                    利用者の同意なく個人情報を第三者に提供することがあります。
                    <br />
                    <br />
                    <ul>
                      <li>利用者本人の同意を得て提供する場合</li>
                      <li>法令に基づく場合</li>
                      <li>人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
                      <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
                      <li>
                        国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、
                        本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
                      </li>
                      <li>合併、会社分割、事業譲渡その他の事由により利用者の個人情報を含む事業の承継がなされる場合</li>
                    </ul>

                  </li>
                  <li>
                    社社は、利用者の同意に基づき個人情報を第三者に提供した場合、以下の事項に関する記録を作成し、保管します。
                    <br />
                    <br />
                    <ul>
                      <li>利用者から事前の同意を得ていること</li>
                      <li>当該第三者の氏名又は名称その他の当該第三者を特定するに足りる事項</li>
                      <li>当該個人情報によって識別される者の氏名その他のその者を特定するに足りる情報</li>
                      <li>当該個人情報の項目</li>
                    </ul>
                  </li>
                  <li>
                    当社は、利用目的の達成に必要な範囲内において、利用者から取得した個人情報（Zenyum治療に必要な範囲の要配慮個人情報を含みます。）
                    の全部又は一部の取扱いを第三者に委託することがあります。この場合、当該委託先において情報の適切な安全管理が図られるよう、必要かつ適切な監督を行います。
                  </li>
                  <li>
                    当社がお客様の個人情報を第三者提供する場合、当社は、当該第三者にお客様の個人情報を保護するよう要求するために最善の努力を払います。
                  </li>
                  <li>
                    当社は、以下のとおりお客様の個人情報等（Zenyum治療に必要な範囲の要配慮個人情報を含みます。）を共同利用します。
                    <br />
                    <br />
                    <table className="table table-bordered">
                      <tr>
                        <td>共同して利用される個人情報の項目</td>
                        <td>
                          【当社の親会社との間で】取得した個人情報の全て【当社の親会社以外のグループ会社および提携歯科医】氏名、連絡先（電話番号・メールアドレス等）、歯の画像および状態に関するデータ
                        </td>
                      </tr>
                      <tr>
                        <td>共同して利用する者の範囲</td>
                        <td>当社の親子会社、グループ会社および提携歯科医</td>
                      </tr>
                      <tr>
                        <td>
                          共同して利用する者の目的
                        </td>
                        <td>
                          Zenyum治療への適合性を判断するための予備的な適合性評価レポートを作成するため、アライナー作成に伴うお客様の治療
                          計画立案の為、お客様の Zenyum治療のサポートの為
                        </td>
                      </tr>
                      <tr>
                        <td>計画立案の為、お客様の Zenyum治療のサポートの為個人情報の管理について責任を有する者の名称</td>
                        <td>株式会社 Zenyum Japan</td>
                      </tr>
                    </table>
                  </li>
                  <li>
                    客様は、当社のサービスをご利用になることにより、当社がお客様に本サービスを提供するためにお客様の個人データを様々な国に転送することが合理的に必要であることに同意されたものとします。
                  </li>
                </ul>
              </li>
              <li>
                個人情報への開示または修正の要求
                <ul>
                  <li>
                    お客様は、いつでも書面による要求を
                    <a href="mailto:smile.japan@zenyum.com">smile.japan@zenyum.com</a>
                    に提出することにより、当社が保有する個人データへの開示または訂正を要求することができます。
                  </li>
                  <li>
                    当社は、お客様のご要望にお応えするために、お客様の身元およびご要望の内容を確認するために、お客様からさらなる情報をお聞きすることがあります。また、
                    お客様のご要望にお応えするために、手数料をお支払いいただく場合があります。
                  </li>
                  <li>
                    お客様のご要望に対応するための十分な情報が得られた場合、別段の定めがない限り、お客様のご要望から 30日以内に、
                    関連する個人データまたは情報を提供するよう努めます。ただし、個人情報保護法その他の法令により当社がこれらの義務を負わない場合、
                    正当な理由なく同内容の請求が何度も繰り返される場合、または過度な技術的作業を要する場合は、これらの手続を行うことができないことがあります。
                  </li>
                </ul>
              </li>
              <li>
                個人情報の削除または利用停止（同意撤回）の申し出
                <ul>
                  <li>
                    お客様がご自身の個人データの使用に対する同意を撤回し、削除または利用停止をされたい場合は、直ちに本サービスのご利用を中止していただき、
                    <a href="mailto:smile.japan@zenyum.com">smile.japan@zenyum.com</a>
                    宛にご自身の個人情報等の収集、使用、共有の中止を希望される旨を記載して当社にお知らせください。また、お客様は、
                    特定の目的のための個人データの使用に対する同意を撤回することもできますので、お客様のご要望にお応えできるよう、通知には十分かつ具体的な情報を記載してください。
                  </li>
                  <li>
                    ただし、お客様が同意を撤回した場合、その撤回に起因して一定の法的影響が生じる可能性があります。これに関連して、
                    当社がお客様の個人データを処理することに対するお客様の同意の撤回の程度によっては、お客様と当社との既存の関係を継続できなくなる可能性があります。
                  </li>
                  <li>
                    お客様からの要求について、個人情報保護法その他の法令により当社がこれらの義務を負わない場合、正当な理由なく同内容の請求が何度も繰り返される場合、
                    または過度な技術的作業を要する場合は、これらの手続を行うことができないことがあります。
                  </li>
                </ul>
              </li>
              <li>
                個人情報等の保持、管理、運用
                <ul>
                  <li>
                    当社は、お客様が当社に提供した情報に基づき、お客様の個人情報等が正確かつ完全であることを確認するための合理的な努力を行います。
                    当社に提供されたすべての情報が最新のものであることを確認し、関連する変更があれば当社に通知してください。
                  </li>
                  <li>
                    当社はお客様のプライバシーを尊重し、お客様の個人情報等が適切に保護され、安全であることを保証するためのセキュリティ対策を講じています。
                    また、当社は、当社が所有または管理するお客様の個人情報等を、以下のことが想定される合理的な時点で、破棄および／または匿名化するような措置を講じます。
                    (i)個人情報等を保持することで、当該個人情報等を収集した目的が達成されなくなった場合。(ii)その他の法的またはビジネス上の目的のために保有する必要がなくなった場合。
                  </li>
                  <li>
                    上記以外の場合、当社が収集した個人情報等は、通常、当該個人情報等が提供された目的のために合理的に必要な期間のみ保持され、当社は、法律、規制、
                    その他の業務上または監査上の要件によって要求されない限り、その後、お客様から提供された情報または個人情報等を破棄または削除することができます。
                  </li>
                  <li>
                    お客様の個人情報等が日本または個人情報等が収集されたその他の管轄区域外に移転される場合、
                    当社は、個人情報等の受領者が本プライバシーポリシーおよび個人情報保護法に準拠してお客様の個人情報等を保護する法的強制力のある義務に拘束されていることを確認するための合理的な措置を講じるものとします。
                  </li>
                </ul>
              </li>
              <li>
                チャネルを通じた個人情報等の共有
                お客様が当社チャネルや他のソーシャルメディア・プラットフォームのパブリック・アカウント設定のユーザーであり、
                Zenyumグループ、Zenyumトリートメント、キャンペーン、製品やサービスに関連するハッシュタグを使用した場合、当社は、
                当社の製品に関するお客様の意見を当社のウェブサイトやチャンネルの訪問者と共有する目的で、当社チャンネルから当社のサービスに関するお客様のレビューを取得して、
                当社のウェブサイトやチャンネルに掲載することができます。あなたのレビュー/フィードバック/コンテンツが当社のウェブサイトやチャンネルで公開されることを望まない場合、
                あなたはここにそのようなハッシュタグを使用しないことに同意します。
                <br />
                <br />
                Zenyum治療に関連したあなたの体験について、チャンネルやソーシャルメディア・プラットフォームにコンテンツを投稿したり、その他の方法で利用可能にしたり、
                当社のウェブサイトやチャンネルであなたのコンテンツを共有する許可を求められた場合に「はい」と答えた場合、あなたは 18歳以上であることを表明・
                保証し、ウェブサイトやチャンネルに記載されている条件に同意したことになります。
              </li>
              <li>
                苦情処理
                <br />
                本ポリシーのいずれかの条項、当社によるあなたの個人情報等の使用に同意されない場合、あるいは当社によるあなたの個人情報等の取り扱いについて苦情や不満がある場合は、
                以下の連絡先に詳細をお寄せください。
                <br />
                <br />
                E-mailアドレス
                <br />
                <a href="mailto:smile.japan@zenyum.com">smile.japan@zenyum.com</a>
              </li>
              <li>
                データ保護方針に関する最新情報
                <ul>
                  <li>
                    お客様の個人データを適切に管理、保護、処理するための努力の一環として、当社は、当社の方針、手順、プロセスを見直し、
                    当社の絶対的な裁量により、本プライバシーポリシーの条件を適宜更新することがあります。改訂されたプライバシーポリシーは、
                    当社のウェブサイトに掲載され、
                    <a href="https://www.zenyum.com/jp-ja/privacy">https://www.zenyum.com/jp-ja/privacy</a>
                    / でアクセスできます。
                  </li>
                  <li>
                    お客様におかれましては、個人情報保護に関する当社の最新の方針を十分にご理解いただくために、上記のウェブサイトを適宜ご覧になることをお勧めします。
                  </li>
                </ul>
              </li>
              <li>
                クッキーポリシー
                <ul>
                  <li />
                  <li>
                    当社は、当社の事業を支援し、お客様に関連するサービスを提供するために、お客様（またはお客様の代理人）から非識別情報を収集することがあります。
                    このような匿名化および非識別化された情報は、法律で認められた目的のために、当社のパートナー、サービスプロバイダー、広告主および／またはその他の第三者との間で、
                    譲渡、開示、譲渡、リース、ライセンス、販売、その他の方法で共有されることがあります。
                  </li>
                  <li>
                    クッキー（お客様のデバイスに置かれる小さなテキストファイルで、お客様の好みに関する情報を記録し、ログインを可能にしたり、
                    興味に応じた広告を提供したり、当社のサービスのパフォーマンスを分析したりします）は、当社が収集するこのような匿名化されたデータの一例です。クッキーは、
                    お客様の閲覧傾向に関する情報を収集するとともに、お客様のユーザーエクスペリエンスを向上させることができます。
                    また、当社のウェブサイトやチャンネルには、第三者のクッキーが存在する場合があります。クッキーの詳細については、
                    <a href="http://allaboutcookies.org/manage-cookies/">allaboutcookies.org/manage-cookies/</a>
                    をご参照ください。
                  </li>
                  <li>
                    お客様は、ウェブブラウザの設定により、クッキーをコントロールすることができます。これにより、どのクッキーを許可し、どのクッキーを拒否するかを決定することができます。
                    当社のウェブサイトやチャンネルでのクッキーの使用を拒否した場合、当社のウェブサイトやチャンネルが提供するすべての機能にアクセスできない可能性があることにご注意ください。
                  </li>
                  <li>
                    当社の広告パートナーも、お客様が本サービスに掲載されている広告をクリックすると、お客様のブラウザやデバイスにクッキーを送信することがあります。
                    さらに、お客様が第三者のウェブサイトやサービスへのリンクをクリックした場合、第三者がお客様にクッキーを送信することもあります。
                  </li>
                  <li>
                    本ポリシーは、第三者によるクッキーの使用をカバーするものではなく、当社は第三者のプライバシーポリシーおよび慣行について責任を負いません。
                    第三者が設置したクッキーは、お客様が本サービスから退出した後も、オンラインでのお客様の行動を追跡し続ける可能性があります。また、これらの第三者は、
                    お客様がブラウザやデバイスを使って設定した「Do Not Track」要求を守らない可能性がありますので、ご注意ください。
                  </li>
                  <li>
                    当社によるクッキーの使用に同意されない場合は、ブラウザの設定を適宜変更するか、本サービスをご利用にならないでください。
                  </li>
                </ul>
              </li>
              <li>
                本ポリシーの変更
                <ul>
                  <li>当社は、個人情報等の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、随時本ポリシーを変更することがあります。</li>
                  <li>
                    更後の本ポリシーについては、当社サービス上又は当社の運営するウェブサイトでの掲示その他分かりやすい方法により告知します。
                    ただし、法令上利用者の同意が必要となるような内容の変更を行う場合は、別途当社が定める方法により、利用者の同意を取得します。
                  </li>
                </ul>
              </li>
            </ol>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
